var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "manufacturer-filter" }, [
    _c("div", { staticClass: "manufacturer-filter__stilrichtungen" }, [
      _c(
        "ul",
        { staticClass: "manufacturer-filter__stilrichtungen--buttons" },
        [
          _c("li", [
            _c(
              "button",
              {
                class: [
                  "manufacturer-filter__button",
                  !_vm.activeStil ? "active" : "",
                ],
                on: {
                  click: function ($event) {
                    _vm.activeStil = 0
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$translate(
                        "TatyouTheme::Template.categoriesArtistFilterAll"
                      )
                    ) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.stils, function (stil) {
            return _c("li", { key: stil.id }, [
              _c(
                "button",
                {
                  class: [
                    "manufacturer-filter__button",
                    _vm.activeStil === stil.id ? "active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      _vm.activeStil = stil.id
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(stil.details[0].name) +
                      "\n                "
                  ),
                ]
              ),
            ])
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "manufacturer-filter__artists" },
      [
        _vm._l(_vm.filteredArtists, function (artist) {
          return _c(
            "a",
            {
              key: artist.id,
              class: [
                "manufacturer-filter__artists--artist",
                artist.faxNumber.includes(_vm.activeStil) || !_vm.activeStil
                  ? "active"
                  : "",
              ],
              attrs: {
                title: artist.externalName,
                href: _vm.manuCategoryLangUrl(
                  artist.manuInformationFromCategories.nameUrl,
                  artist.manuInformationFromCategories.lang
                ),
              },
            },
            [
              _c(
                "div",
                { staticClass: "manufacturer-filter__artists--artist-image" },
                [
                  _c("img", {
                    attrs: { src: artist.logo, alt: artist.externalName },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(artist.externalName))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(artist.town) + ", " + _vm._s(artist.countryName)),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        !_vm.resultsLength
          ? _c("div", { staticClass: "manufacturer-filter__artists-empty" }, [
              _c("h3", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$translate(
                        "TatyouTheme::Template.categoriesFilterNoResults"
                      )
                    ) +
                    "\n            "
                ),
              ]),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }